import mod from "-!./Menu.js?vue&type=script&lang=js&"; export default mod; export * from "-!./Menu.js?vue&type=script&lang=js&"